export const QUOTE_LOADING_BATCH = 50;